var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAccordionMinus = function SvgAccordionMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19C19.4142 11.25 19.75 11.5858 19.75 12C19.75 12.4142 19.4142 12.75 19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12Z",
    fill: "#1C6E94",
    stroke: "#1C6E94",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC4yNSAxMkM0LjI1IDExLjU4NTggNC41ODU3OSAxMS4yNSA1IDExLjI1SDE5QzE5LjQxNDIgMTEuMjUgMTkuNzUgMTEuNTg1OCAxOS43NSAxMkMxOS43NSAxMi40MTQyIDE5LjQxNDIgMTIuNzUgMTkgMTIuNzVINUM0LjU4NTc5IDEyLjc1IDQuMjUgMTIuNDE0MiA0LjI1IDEyWiIgZmlsbD0iIzFDNkU5NCIgc3Ryb2tlPSIjMUM2RTk0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+DQo8L3N2Zz4NCg0K";
export { SvgAccordionMinus as ReactComponent };